//#region src/errors/invalid-token-error.ts
var e = [
	"Invalid JWT Token",
	"JWT Token not found",
	"Expired JWT Token"
], t = class extends Error {
	constructor() {
		super(), this.name = this.constructor.name;
	}
};
//#endregion
export { t as InvalidTokenError, e as invalidTokenErrorMessages };
